import React, { useEffect, useRef, useState } from "react";
import "./BusinessThreeServices.scss";

const BusinessThreeServices = ({ id }) => {
  const headingRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);
  const [slideClass, setSlideClass] = useState("slide-in");

  //const icons = ["room_service", "sound_boost", "vacuum", "directions_car", "local_dining"];

  const services = [
    "Digital Signage",
    "Hologram",
      "Pro Video",
    "LED Walls",
  
    "Meeting Room Solutions",
  ];

  const serviceContents = [
    {
      heading: "Smart Digital Signage Solutions",
      description:
      "Enhance customer engagement and brand visibility with dynamic digital displays. Deliver real-time content, promotions, and updates with ease.",


      image:
      "https://qkc08.upcloudobjects.com/stgencntsg/Blogs/Image-2.webp",
      alt: "LIGHTING EXPRESS",
    },
    {
      heading: "Next-Gen Hologram Display Solutions",
      description:
      "Bring your brand to life with cutting-edge 3D holographic visuals. Ideal for marketing, exhibitions, and immersive experiences.",





      image:
      "https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://media.easy-peasy.ai/a3fba0a2-c146-418a-9d3d-cc220c76333d/bd3f035f-249a-47b8-b4cd-fb71216302e5.png",
      alt: "wifi img",
    },
    {
      heading: "Pro Video Display Solutions",
      description:
      "Deliver crystal-clear visuals with high-definition video playback for events, promotions, and digital signage.",




      image:
      "https://syslabme.com/wp-content/uploads/2025/01/Digital_Signage_3_4K-1536x864.webp",
      alt: "houskeeping img",
    },
    {
      heading: "High-Resolution LED Video Walls",
      description:
"Deliver stunning visuals with seamless, bright, and scalable LED walls — perfect for presentations, advertising, and digital signage.",


      image:
      "https://syslabme.com/wp-content/uploads/2025/01/led-wall-1536x864.webp",
      alt: "car img",
    },
    {
      heading: "Complete Meeting Room Technology",
      description:
      "From interactive displays to conferencing systems, we offer end-to-end solutions for efficient and productive meetings.",


      image:
      "https://syslabme.com/wp-content/uploads/2025/01/Meeting_Room_4_4K-1536x864.webp",
      alt: "in room dining img",
    },
  ];

  const handleTabClick = (index) => {
    if (index !== activeTab) {
      setSlideClass("slide-out");
      setTimeout(() => {
        setActiveTab(index);
        setSlideClass("slide-in");
      }, 500); // Matches the duration of the transition
    }
  };

  // CODE START FOR ANIMATION HEADING
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          } else {
            entry.target.classList.remove("animate");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => {
      if (headingRef.current) {
        observer.unobserve(headingRef.current);
      }
    };
  }, []);
  // CODE END FOR ANIMATION HEADING

  return (
    <>
      <div className="large_padding_div" id={id}></div>
      <div className="container business-three-box-container">
        <div ref={headingRef} className="business-three-heading-div">
          <h3>
            <span>Your Comfort,</span> Our Top Priority
          </h3>
        </div>
        <div className="business-three-template-view-more-icon">
          <span className="material-symbols-outlined">arrow_forward_ios</span>{" "}
        </div>
      </div>
      <div className="container">
        <div className="d-flex align-items-center justify-content-between business-three-services-top-selector">
          {services.map((service, index) => (
            <div
              key={index}
              onClick={() => handleTabClick(index)}
              className={`business-three-service-tab ${
                activeTab === index ? "active" : ""
              }`}
            >
              {/* <span className="material-symbols-outlined">{icons[index]}</span> */}
              &nbsp;
              {service}
            </div>
          ))}
        </div>
        <br />
        <div className="business-three-service-selected-service">
          <div
            className={`business-three-service-selected-service-content ${slideClass}`}
          >
            <div className="row d-flex align-items-center">
              <div className="col-12 col-md-6">
                <h4 style={{ fontSize:"1.8rem", fontWeight:"700", color:"var(--black-color)" }}>
                  {serviceContents[activeTab].heading}
                </h4>
                <br />
                <p>{serviceContents[activeTab].description}</p>
                <br />
                <div>
                  <button className="btn_border">{services[activeTab]}</button>
                </div>
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-end">
                <img
                  src={serviceContents[activeTab].image}
                  alt={serviceContents[activeTab].alt}
                  className="business-three-service-selected-service-img"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="business-three-dots-container">
          {services.map((_, index) => (
            <div
              key={index}
              className={`business-three-dot ${
                activeTab === index ? "active" : ""
              }`}
            ></div>
          ))}
        </div>
      </div>
      <div className="large_padding_div"></div>
    </>
  );
};

export default BusinessThreeServices;
